import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ITaskDelayFailure } from '../../interfaces/delay-failure/task-delay-failure';
import { EventService } from '../../services/event.service';
import { DelayFailureService } from '../../services/delay-failure.service';

@Component({
  selector: 'job-screen-delay-failures',
  templateUrl: './job-screen-delay-failures.component.html',
  styleUrls: ['./job-screen-delay-failures.component.scss'],
})
export class JobScreenDelayFailuresComponent implements OnInit, OnDestroy {
  @Input() set jobId(value: number) {
    this._jobId = value;
  }
  private _jobId: number;

  delayFailures: ITaskDelayFailure[];
  refreshSub: Subscription;
  loading = false;

  constructor(
    private eventService: EventService,
    private delayFailureService: DelayFailureService,
  ) {}

  ngOnInit(): void {
    this.load();

    this.refreshSub = this.eventService.DelayFailureRefreshEvent.subscribe(() => {
      this.load();
    });
  }

  ngOnDestroy() {
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
    }
  }

  load() {
    this.loading = true;
    this.delayFailureService
      .getJobDelayFailures(this._jobId)
      .then((res) => {
        this.delayFailures = res;
        this.loading = false;
      })
      .catch((err) => {
        console.log('Error Loading Delay/Failures: ', err);
        this.loading = false;
      });
  }
}
